/**
 * Swiper bundle for Page Designer / templates: init carousels marked with [data-lvz-swiper].
 * Markup: https://swiperjs.com/swiper-api
 */
import Swiper from 'swiper';
import { A11y, Keyboard, Navigation, Pagination } from 'swiper/modules';

(function initLvzSwiper() {
	/**
	 * @param {HTMLElement} root
	 * @returns {Record<string, unknown>}
	 */
	function parseConfig(root) {
		let raw = root.getAttribute('data-lvz-swiper-config');
		if (!raw) {
			return {};
		}
		try {
			return JSON.parse(raw);
		} catch (e) {
			return {};
		}
	}

	/**
	 * @param {HTMLElement} root
	 * @returns {number}
	 */
	function resolveSlidesPerView(root) {
		let slidesPerView = document.currentScript.getAttribute('slidesperview');
		if (!slidesPerView || slidesPerView == 'null' || slidesPerView == 'undefined' || slidesPerView == '') {
			slidesPerView = root.getAttribute('data-slides-per-view') || 1;
		}
		return parseInt(slidesPerView);
	}

	/**
	 * @param {Record<string, unknown>} config
	 * @param {Element} swiperEl
	 * @param {Record<string, unknown>} userConfig
	 * @param {boolean} isSquaredCard
	 */
	function applyNavAndPagination(config, swiperEl, userConfig, isSquaredCard) {
		if (isSquaredCard) {
			let userPagination = userConfig.pagination || {};
			let userNavigation = userConfig.navigation || {};
			delete userConfig.pagination;
			delete userConfig.navigation;

			Object.assign(config, userConfig);

			let pagSquared = swiperEl.querySelector('.swiper-pagination');
			if (pagSquared) {
				config.pagination = Object.assign({ el: pagSquared, clickable: true }, userPagination);
			}
			let nextSquared = swiperEl.querySelector('.swiper-button-next');
			let prevSquared = swiperEl.querySelector('.swiper-button-prev');
			if (nextSquared && prevSquared) {
				config.navigation = Object.assign({ nextEl: nextSquared, prevEl: prevSquared, addIcons: false }, userNavigation);
			}
			return;
		}

		let pag = swiperEl.querySelector('.swiper-pagination');
		if (pag) {
			config.pagination = { el: pag, clickable: true };
		}
		let next = swiperEl.querySelector('.swiper-button-next');
		let prev = swiperEl.querySelector('.swiper-button-prev');
		if (next && prev) {
			config.navigation = { nextEl: next, prevEl: prev, addIcons: false };
		}

		Object.assign(config, userConfig);
	}

	/**
	 * @param {HTMLElement} root
	 */
	function initOne(root) {
		if (root.getAttribute('data-lvz-swiper-initialized') === 'true') {
			return;
		}
		let swiperEl = root.classList.contains('swiper') ? root : root.querySelector('.swiper');
		if (!swiperEl) {
			return;
		}

		let userConfig = parseConfig(root);
		if (Object.prototype.hasOwnProperty.call(userConfig, 'modules')) {
			delete userConfig.modules;
		}

		let slidesPerView = resolveSlidesPerView(root);

		/** @type {Record<string, unknown>} */
		let config = {
			modules: [Navigation, Pagination, A11y, Keyboard],
			slidesPerView: 1.5,
			centeredSlides: true,
			breakpoints: {
				768: {
					slidesPerView: slidesPerView,
					centeredSlides: false
				}
			},
			watchOverflow: true,
			a11y: {
				enabled: true
			}
		};

		applyNavAndPagination(config, swiperEl, userConfig, !!root.closest('.lvz-squared-card-container'));

		// eslint-disable-next-line no-new
		new Swiper(swiperEl, config);
		root.setAttribute('data-lvz-swiper-initialized', 'true');
	}

	function initAll() {
		document.querySelectorAll('[data-lvz-swiper]').forEach(function (el) {
			initOne(el);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}
})();
